enum WorkflowType {
    ANGULAR = 0,
    PATCH = 1,
    ANGULAR_SCOPE = 2,
    PATCH_SCOPE = 3
}

export default WorkflowType